import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                                   */
const PrescriptionFormColumnHeading = ({ id, className, children }) => /* @__PURE__ */ React.createElement(
  Heading,
  {
    component: "h3",
    variant: "subheading2",
    id,
    className: classnames("prescription-form-column__heading-text", className)
  },
  children
);
export {
  PrescriptionFormColumnHeading
};
//# sourceMappingURL=PrescriptionFormColumnHeading.js.map
